import { nextTick } from "vue";

export async function focusNextSiblingOnRemove(event: Event, removeAction: () => void): Promise<void> {
  const button = event.currentTarget instanceof HTMLElement ? event.currentTarget : null;
  const container = button?.parentElement ?? null;
  const siblings = container
    ? Array.from(container.querySelectorAll<HTMLButtonElement>(":scope > button"))
    : [];
  const index = button ? siblings.indexOf(button as HTMLButtonElement) : -1;

  removeAction();

  await nextTick();

  if (!container) return;
  const nextSiblings = Array.from(container.querySelectorAll<HTMLButtonElement>(":scope > button"));
  const next = nextSiblings[index] ?? nextSiblings[nextSiblings.length - 1];
  if (next) {
    next.focus();
    return;
  }

  const trigger = container.parentElement?.parentElement?.querySelector<HTMLButtonElement>(
    'button[aria-haspopup="dialog"]'
  );
  trigger?.focus();
}
